import { render, staticRenderFns } from "./CardServidor.vue?vue&type=template&id=2f65fbb4&scoped=true&"
import script from "./CardServidor.vue?vue&type=script&lang=js&"
export * from "./CardServidor.vue?vue&type=script&lang=js&"
import style0 from "./CardServidor.vue?vue&type=style&index=0&id=2f65fbb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65fbb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAvatar,VBtn,VCard,VChip,VIcon,VProgressLinear})
